import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { TaskViewViewModel } from 'src/pages/TasksPage/TaskViewViewModel';
import styled from 'styled-components';

export const AgentTaskViewHeader = observer(() => {
    const { t } = useTranslation();

    if (!TaskViewViewModel.taskDefinition) {
        return null;
    }
    const { taskDefinition } = TaskViewViewModel;

    const hasL10nTitleKey = Boolean(taskDefinition.extensions?.l10nTitleKey);
    const title = hasL10nTitleKey
        ? t(`${taskDefinition.extensions?.l10nTitleKey}`, {
              ...taskDefinition?.taskInfo,
          })
        : taskDefinition.name;

    return (
        <StyledTitlte data-testid="tasks-item-header-title">
            {title}
        </StyledTitlte>
    );
});

const StyledTitlte = styled(Typography.Title)`
    padding-left: 1.6rem;
    margin-bottom: 1.8rem !important;
`;
